  window.addEventListener('load', function() {
    $('button:contains("Add to Cart"), button:contains("Add to Basket")').on('click', function() {
      var proname = $(this).parents(".product-grid-item").find('.product-item-title').text();
      ga('send', 'event', 'category to cart', 'click', proname);
    });

    // ---- Footer Links Desktop----
    $('.global-block li a').on('click',function() {
      ga('send', 'event', 'Bottom Nav', 'Clicked '+$(this).html(), ''); 
    });

    // ---- Start Footer links Mobile ----
    $('.mobile-menu-side li a').on('click', function() { 
      ga('send', 'event', 'Bottom Nav', 'Clicked '+$(this).html(), ''); 
    });

    // ---- Start Top Nav Desktop ----
    $('.promo-banner').on('click',function() {
      ga('send', 'event', 'Upper Navigation Bar 4.0', 'Clicked Promo Banner', '');
    });

    $('.site-header__logo-link').on('click', function() {
      ga('send', 'event', 'Upper Navigation Bar 4.0', 'Clicked HB logo', '');
    });

    $('.site-nav__dropdown--shop .site-nav__child-link, .site-nav-mobile__dropdown--shop .site-nav-mobile__child-link').on('click', function() {
      ga('send', 'event', 'Upper Navigation Bar 4.0', 'Clicked Shop > '+ $(this).find('.site-nav__label').text().replace(/\s\s/g, ' '), '');
    });

    $('.site-nav__link--shop, .site-nav-mobile__link--main--shop, .site-nav-mobile__link--main--shop > a').on('click', function() {
      ga('send', 'event', 'Upper Navigation Bar 4.0', 'Clicked Shop', '');
    });

    $('.site-nav__dropdown--reviews .site-nav__dropdown__item--snoo-smart-sleeper a, .site-nav-mobile__dropdown--reviews .site-nav-mobile__dropdown__item--snoo-smart-sleeper a').on('click', function() {
      ga('send', 'event', 'Upper Navigation Bar 4.0', 'Clicked Reviews SNOO', '');
    });

    $('.site-nav__dropdown--reviews .site-nav__dropdown__item--sleepea-swaddle a, .site-nav-mobile__dropdown--reviews .site-nav-mobile__dropdown__item--sleepea-swaddle a').on('click', function() {
      ga('send', 'event', 'Upper Navigation Bar 4.0', 'Clicked Reviews Sleepea', '');
    });

    $('.site-nav__link--blog, .site-nav-mobile__link--main--blog').on('click', function(e) {
      ga('send', 'event', 'Upper Navigation Bar 4.0', 'Clicked Blog', '');
    });

    $('.site-nav__link--faqs, .site-nav-mobile__link--main--faqs').on('click', function() {
      ga('send', 'event', 'Upper Navigation Bar 4.0', 'Clicked FAQs', '');
    });

    $('.site-nav__link--main--rental-login, .site-nav-mobile__link--main--rental-login').on('click', function() {
      ga('send', 'event', 'Upper Navigation Bar 4.0', 'Clicked Rental Login', '');
    });

    $('.site-nav__link--bag-icon').on('click', function() {
      ga('send', 'event', 'Upper Navigation Bar 4.0', 'Clicked on Cart', '');
    });


    // Start ---------- Homepage 4.0 Desktop and Mobile--------------
    $('body.template__index [data-track="hp-video-how-snoo-works"]').on('click', function() {
      ga('send', 'event', 'Homepage 4.0', 'Clicked on Watch How SNOO Works button in Harvey section');
    });

    $('.top-hero__btn, .top-hero__btn--buy-now').on('click', function() {
        ga('send', 'event', 'Homepage 4.0', 'Clicked Buy Now on Homepage', '');
    });

    $('.top-hero__btn--rent-now').on('click', function() {
        ga('send', 'event', 'Homepage 4.0', 'Clicked Rent Now on Homepage', '');
    });

    $('.top-hero__link-why-rent').on('click', function() {
        ga('send', 'event', 'Homepage 4.0', 'Clicked Why Rent on Homepage', '');
    });

    $('.modal--why-rent .btn--rent-now').on('click', function() {
        ga('send', 'event', 'Why Rent Modal', 'Clicked Rent Now from Why Rent Modal', '');
    });

    // Start --------- SNOO  ----------

    $('body.template__product--snoo .pdp-product__main-photo .swiper-button-prev').on('click', function () {
      ga('send', 'event', '{{ ga_cat }}', 'Clicked on Image carrot previous', '');
    });

    $('body.template__product--snoo .pdp-product__main-photo .swiper-button-next').on('click', function () {
      ga('send', 'event', '{{ ga_cat }}', 'Clicked on image carrot next', '');
    });

    $('body.template__product--snoo .pdp-product__image-container li').on('click', function () {
      ga('send', 'event', '{{ ga_cat }}', 'Clicked on thumbnail image', '');
    });


    // Start --------- AJAX Cart ----------
    $('.upsell__add-btn').on('click', function(e) {
      var upsellTitle = $(this).parent().parent().find('.upsell__product-info a').html();
      ga('send', 'event', 'AJAX Cart', 'Added '+upsellTitle, '');
    });

  });